module.exports = function() {
  return new Worker(__webpack_public_path__ + "9974c1df873808216d25.worker.js");
};